import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import { animateElements, checkLocalSavedData, playExplosionAnimation } from "../helpers/levelManager"
import {
	displayInstructions,
	destroyInstructions,
	displayTooltip,
	playUISound,
	displayTutorialHand
} from "../helpers/levelManager"
export default class RadarScene extends Phaser.Scene {
	constructor() {
		super({ key: "RadarScene" })
	}

	init() {
		// Game dimensions and scaling
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		let scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		this.userData = checkLocalSavedData()
		this.currentPlanet =
			this.userData === null ? 0 : this.userData.currentPlanet
		this.planetDataMain = this.cache.json.get("userGameData")
		this.planetData = this.planetDataMain.planets
		this.planetName = this.planetData[this.currentPlanet - 1].name
		console.log(
			"Current Planet " +
			this.currentPlanet +
			"Current Planet Name : " +
			this.planetData[this.currentPlanet - 1].name,
		)
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		this.anims.create({
			key: "radar_scan",
			frames: this.anims.generateFrameNames("radarScan", {
				start: 0,
				end: 121,
				zeroPad: 4,
				prefix: "radar_",
				suffix: ".png",
			}),
			frameRate: 15,
			repeat: -1,
		})

		let savedLevel = this.userData === null ? 0 : this.userData.userLevel

		this.currentPlanet =
			this.userData === null ? 0 : this.userData.currentPlanet

		this.maxCount

		if (this.currentPlanet === 1) {
			this.maxCount = 2
		}

		if (this.currentPlanet === 2) {
			this.maxCount = 3
		}

		if (this.currentPlanet === 3) {
			this.maxCount = 3
		}

		this.transparentBG = this.add
			.image(this.gameW / 2, this.gameH / 2, "wideContainer")
			.setOrigin(0.5)
			.setScale(200)
		this.transparentBG.setTint(0xcdfdff).setAlpha(0.75)

		this.radarImage = this.add.image(this.gameW / 2, this.gameH / 2, "radar")
		this.radarImage.setScale(this.scaleFactor)

		this.radarScan = this.add
			.sprite(this.radarImage.x, this.radarImage.y, "radar_scan")
			.setScale(this.scaleFactor).setDepth(6)
		this.radarScan.play("radar_scan")

		this.radarInstHolder = this.add.image(
			this.radarImage.x - this.radarImage.width * this.scaleFactor * 0.5 / 2 - 60 * this.scaleFactor,
			this.radarImage.y - this.radarImage.height * this.scaleFactor * 0.5 / 2 - 35 * this.scaleFactor,
			"radarInst")
			.setScale(this.scaleFactor * 0.5)
		this.radarInstText = this.add.rexBBCodeText(
			this.radarInstHolder.x - this.radarInstHolder.width * this.scaleFactor * 0.5 / 2 + 12 * this.scaleFactor,
			this.radarInstHolder.y - this.radarInstHolder.height * this.scaleFactor * 0.5 / 2 + 10 * this.scaleFactor,
			"Press the [color=#CD0172][b]PINK[/b][/color]\ndots to find:\n[b]3 creatures[/b]",
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 6 * this.scaleFactor,
				color: "#11044E",
				align: "center",
				wrap: {
					mode: "word",
					width: 460 * this.scaleFactor,
				},
				lineSpacing: 3,
				resolution: 2,
			},
		).setDepth(2)

		// Initialize the creature count to zero
		this.creatureCount = 0
		this.creatureTally = this.add
			.image(
				this.radarImage.x - 180 * this.scaleFactor,
				this.radarImage.y + 140 * this.scaleFactor,
				"creatureTally",
			)
			.setScale(this.scaleFactor * 0.6)
		this.creatureTallyText = this.add
			.text(
				this.creatureTally.x + 30 * this.scaleFactor,
				this.creatureTally.y - 5 * this.scaleFactor,
				this.creatureCount + "/" + this.maxCount,
				{
					fontSize: this.fontSize + 5 * this.scaleFactor + "px",
					fontFamily: '"Gluten", sans-serif',
					fill: "#11044E",
					fontWeight: "800",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)

		if (this.currentPlanet === 1) {
			// displayInstructions(
			// 	this,
			// 	"Tap the orange circles on your radar to beam up creatures using your ship. Catch both to continue the mission!",
			// 	12,
			// 	700,
			// 	50,
			// )
			this.radarInstText.setText(
				"Press the [color=#CD0172][b]PINK[/b][/color]\ndots to find:\n[b]2 creatures[/b]"
			)
		}

		// if (this.currentPlanet === 2) {
		// 	displayInstructions(
		// 		this,
		// 		"Tap the orange circles on your radar to beam up creatures using your ship. Catch all 3 to continue the mission!",
		// 		12,
		// 		700,
		// 		50,
		// 	)
		// }

		// if (this.currentPlanet === 3) {
		// 	displayInstructions(
		// 		this,
		// 		"Tap the orange circles on your radar to beam up creatures using your ship. Catch all 3 to continue the mission!",
		// 		12,
		// 		700,
		// 		50,
		// 	)
		// }

		this.nextButton = this.add
			.image(
				this.radarImage.x + 325 * this.scaleFactor,
				this.radarImage.y + 140 * this.scaleFactor,
				"miniWideBtn",
			)
			.setScale(0.5 * this.scaleFactor)
		this.nextButtonText = this.add
			.text(
				this.nextButton.x,
				this.nextButton.y - 5 * this.scaleFactor,
				"Next",
				{
					fontSize: this.fontSize + "px",
					fontFamily: '"Gluten", sans-serif',
					fill: "#fff",
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)

		this.nextButton.setAlpha(0.5)
		this.nextButtonText.setAlpha(0.5)
		this.creatureHunt()
	}

	creatureHunt() {
		let creature = this.add
			.image(0, 0, "radarDot")
			.setInteractive()
			.setAlpha(0)
			.setScale(this.scaleFactor)
			.setDepth(5)
		creature.setVisible(false)

		// creature spawn timer
		this.creatureTimer = this.time.addEvent({
			delay: 2500,
			callback: function () {
				creature.setPosition(
					Phaser.Math.Between(
						this.radarImage.x - 60 * this.scaleFactor,
						this.radarImage.x + 160 * this.scaleFactor,
					),
					Phaser.Math.Between(
						this.radarImage.y - 80 * this.scaleFactor,
						this.radarImage.y + 80 * this.scaleFactor,
					),
				)
				creature.setVisible(true)
				playUISound(this, this.soundManager, "radar-sonar-ping", 0.45)
				this.tweens.add({
					targets: creature,
					alpha: 1,
					duration: 450,
					onComplete: function () {
						//console.log('creature appeared');
					},
					callbackScope: this,
				})

				//disappear timer
				this.disappearTimer = this.time.addEvent({
					delay: 1000,
					callback: function () {
						this.tweens.add({
							targets: creature,
							alpha: 0,
							duration: 450,
							onComplete: function () {
								creature.setVisible(false)
							},
							callbackScope: this,
						})
					},
					callbackScope: this,
					loop: false,
				})
			},
			callbackScope: this,
			loop: true,
		})

		creature.on(
			"pointerdown",
			function () {
				playUISound(this, this.soundManager, "Click-pop1", 0.25)
				// When creature is tapped
				this.tweens.killTweensOf(creature)
				creature.setVisible(false)
				creature.setAlpha(0)

				// Increment the creature count
				this.creatureCount++
				this.creatureTallyText.setText(
					this.creatureCount.toString() + "/" + this.maxCount,
				)
				this.showCapturedCreature(this.creatureCount)

				// Check if we've reached max creatures
				if (this.creatureCount >= this.maxCount) {
					// If we've caught 4 creatures, stop all timers and proceed to next stage
					this.creatureTimer.remove()
					if (this.disappearTimer) this.disappearTimer.remove()
					//console.log('All creatures caught!');

					// Here you can add code to proceed to the next game stage
					this.time.delayedCall(
						1000,
						function () {
							// For example: this.scene.start('NextScene');
							// Or show a success message
							this.showSuccess()
						},
						[],
						this,
					)
				} else {
					// If we haven't caught 4 creatures yet, clear the current timers
					// but don't stop the overall creature hunt
					if (this.disappearTimer) this.disappearTimer.remove()
				}
			},
			this,
		)
	}

	showCapturedCreature(count) {
		let creatureID
		let yOffset
		const planetCreatureMap = {
			1: [1, 2],
			2: [3, 4, 5],
			3: [6, 7, 8],
			4: [7, 8],
		}

		creatureID = planetCreatureMap[this.currentPlanet][count - 1]

		yOffset = 150 - (count - 1) * 60

		let capturedCreature = this.add
			.image(
				this.radarImage.x - 325 * this.scaleFactor,
				this.radarImage.y + yOffset * this.scaleFactor,
				"creature0" + creatureID + "_thumb",
			)
			.setScale(this.scaleFactor)
			.setScale(0)

		this.tweens.add({
			targets: capturedCreature,
			scale: this.scaleFactor / 2,
			duration: 250,
			ease: "Back.Out",
			callbackScope: this,
		})
	}

	showSuccess() {
		// Create a success message
		playUISound(this, this.soundManager, "success-audio", 0.25)

		destroyInstructions(this)
		let successBG = this.add
			.image(this.gameW / 2, this.gameH / 2, "radarWinContainer")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.6)
		let successText = this.add
			.text(
				successBG.x,
				successBG.y - 1 * this.scaleFactor,
				`Press ‘NEXT’ to safely load them onto the spaceship`,
				{
					fontSize: this.fontSize - 6 * this.scaleFactor + "px",
					fontFamily: '"Space Grotesk", sans-serif',
					fill: "#11044E",
					align: "center",
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
			.setDepth(3)

		let wllDoneText = this.add
			.text(
				successBG.x,
				successBG.y - 25 * this.scaleFactor,
				`Well Done`,
				{
					fontSize: this.fontSize + 4 * this.scaleFactor + "px",
					fontFamily: '"Gluten", sans-serif',
					fill: "#11044E",
					align: "center",
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
			.setDepth(3)

		this.radarScan.stop()
		this.tweens.add({
			targets: this.radarScan,
			alpha: 0,
			duration: 750,
			onComplete: function () {
				this.radarScan.setVisible(false)
			},
			callbackScope: this,
		})

		animateElements([successBG, successText, wllDoneText], this)
		this.nextButton.setAlpha(1)
		this.nextButton.setInteractive()
		this.nextButtonText.setAlpha(1)
		this.time.delayedCall(1500, function () {
			playExplosionAnimation(this, {
				x: wllDoneText.x,
				y: wllDoneText.y,
				lifespan: 1000,
				//scale: 2 * this.scaleFactor,
				depth: 1
			})
		}, [], this)
		this.nextButton.on(
			"pointerdown",
			function () {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				const cockpitScene = this.scene.get("CockpitScene")

				this.scene.resume("CockpitScene")

				//cockpitScene.tablet.setVisible(false);
				cockpitScene.radar.setVisible(false)
				cockpitScene.frontButton.setVisible(true)
				cockpitScene.backButton.setVisible(true)

				//cockpitScene.moveCockpit(-1);
				if (this.currentPlanet === 1) {
					displayInstructions(
						cockpitScene,
						"The creatures are in the tubes. Time to care for them!",
						14,
						400,
						60,
					)

					displayTutorialHand(cockpitScene, {
						xPos: cockpitScene.frontButton.x - 70 * cockpitScene.scaleFactor,
						yPos: cockpitScene.frontButton.y - 40 * cockpitScene.scaleFactor,
						rotation: 120
					})
					cockpitScene.tutorialHand.setDepth(50000)
					// displayTooltip(cockpitScene, {
					// 	xPos: cockpitScene.fuelGauge.x - 190 * this.scaleFactor,
					// 	yPos: cockpitScene.fuelGauge.y,
					// 	type: "leftMediumTip",
					// 	scale: 1.1,
					// 	text: "This is your Fuel Gauge.\nIt needs to be full before leaving\nthis planet so keep an eye on it!",
					// 	// text: "This is your Fuel Gauge.\nIt needs to be full before leaving this planet so keep an eye on it!",
					// 	fontScale: -8,
					// 	xTextOffset: -2,
					// 	yTextOffset: 0,
					// 	wrapWidth: 0.9,
					// })
					cockpitScene.planetNamePanel.setVisible(true)
					cockpitScene.tabletButton.setVisible(true)
					cockpitScene.tabletButton.setAlpha(0.5)
				} else {
					displayInstructions(
						cockpitScene,
						"Press the left and right arrow buttons to look around your ship",
						14,
						500,
						60,
					)
					cockpitScene.planetNamePanel.setVisible(true)
				}

				this.scene.stop("RadarScene")
			},
			this,
		)
	}
}
